import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js'
import { Bar } from 'vue-chartjs'

// Register ChartJS components

export default {
  __name: 'BarChart',
  props: {
  chartData: {
    type: Object,
    required: true
  },
  chartOptions: {
    type: Object,
    default: () => ({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'top'
        },
        title: {
          display: true,
          text: 'Bar Chart'
        }
      },
      scales: {
        x: {
          grid: {
            display: false
          }
        },
        y: {
          grid: {
            display: false
          }
        }
      }
    })
  }
},
  setup(__props) {

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

// Define props for the chart data
const props = __props

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(Bar), {
    data: __props.chartData,
    options: __props.chartOptions
  }, null, 8, ["data", "options"]))
}
}

}